<script>
import MainButton from "@/components/Common/Buttons/MainButton.vue";
import UniHospitalLogo from "@/components/Common/Icons/UniHospitalLogo.vue";
import HamburgerMenuIcon from "@/components/Common/Icons/HamburgerMenuIcon.vue";
import PhoneIcon from "@/components/Common/Icons/PhoneIcon.vue";
import ClockIcon from "@/components/Common/Icons/ClockIcon.vue";

import FacebookIcon from "@/components/Common/Icons/FacebookIcon.vue";
import InteraLogo from "@/components/Common/Icons/InteraLogo.vue";
import InstagramIcon from "@/components/Common/Icons/InstagramIcon.vue";


export default {
  components: {
    InstagramIcon,
    FacebookIcon,

    MainButton,
    UniHospitalLogo,
    HamburgerMenuIcon,
    ClockIcon,
    PhoneIcon,
    InteraLogo

  },
  data() {
    return {
      showSubmenu: false,

    };
  },
  methods: {
    async showMenu() {
      await this.$store.dispatch("utils/toggleOfficesModal", true);
    },
  }
};
</script>

<template>
  <nav class="footer-wrapper">
    <div class="footer-top nav-container   d-md-grid ">
      <div class="nav-left d-flex d-md-block justify-content-center">
        <router-link :to="{name: 'home'} ">
          <UniHospitalLogo/>
        </router-link>
      </div>
      <div class="menu-navigation d-md-flex text-center">
        <div class="navigation-item justify-content-center d-flex" @click="showMenu">
          <div class="d-md-flex d-none align-self-center icon ">
            <HamburgerMenuIcon/>
          </div>
          <div>{{ $t('offices') }}</div>
        </div>
        <router-link :to="{name: 'TeamView'  }">
          <div class="navigation-item"> {{ $t('team') }}</div>
        </router-link>
        <router-link :to="{name: 'VenousCenterView'  }">
          <div class="navigation-item"> {{ $t('venous-center') }}</div>
        </router-link>
        <router-link v-if="false" :to="{name: 'ServicesView'} ">
          <div class="navigation-item"> {{ $t('services') }}</div>
        </router-link>
        <router-link :to="{name: 'AboutUsView'} ">
          <div class="navigation-item"> {{ $t('about-us') }}</div>
        </router-link>
        <router-link :to="{name: 'NewsView'} ">
          <div class="navigation-item"> {{ $t('news') }}</div>
        </router-link>
        <router-link :to="{name: 'ContactsView'} ">
          <div class="navigation-item"> {{ $t('contacts') }}</div>
        </router-link>
      </div>
      <div class="nav-right  ">
        <a class="d-flex justify-content-center align-items-center"
           href="https://www.facebook.com/profile.php?id=61559825903271">
          <FacebookIcon/>
          <div class="ms-lg-1 navigation-item-small">Facebook</div>
        </a>
        <a class="ms-lg-4 d-flex justify-content-center align-items-center"
           href="https://www.instagram.com/uni_hospital_medicalcenter/">
          <InstagramIcon/>
          <div class="ms-lg-1 navigation-item-small">Instagram</div>
        </a>
      </div>
    </div>
    <div class="footer-middle d-md-flex w-100 ">
      <div class="">
        <div class="footer-contact-info  d-md-flex">
          <a class="d-flex align-items-center justify-content-center" href="tel:+359884 64 87 11">
            <PhoneIcon/>
            <div class="ms-1">0884 64 87 11</div>
          </a>
          <div class="d-flex ms-lg-5 align-items-center justify-content-center">
            <ClockIcon/>
            <div class="ms-1">{{ $t('working-days') }}: {{ $t('working-hours') }}</div>
          </div>
        </div>
        <div class="footer-contact-info "> {{ $t('unihospital-address') }}</div>
      </div>
      <div class=" d-md-flex ms-auto align-items-center appointments-button">
        <div class="d-flex justify-content-center">
          <a :href="$router.resolve({name: 'BookAppointmentView'}).href">
            <MainButton :buttonText="$t('book-appointment-online')" :icon="'calendar'" :size="'medium'"
                        :theme="'solid-brown'"/>
          </a>
        </div>
      </div>
    </div>
    <div class="footer-bottom nav-container d-block   d-md-grid ">
      <div class="nav-left d-block text-center d-md-flex ">
        <div class="navigation-item-small"> {{ $t('terms-and-conditions') }}</div>
        <div class="navigation-item-small"> {{ $t('privacy-policy') }}</div>
      </div>
      <div class="menu-navigation d-md-flex text-center">
        <div class="footer-contact-info">
          {{ $t('copyright-all-rights-reserved') }}
        </div>

      </div>
      <div class="nav-right  d-flex   align-items-center">
        <a href="http://www.intera.bg">
          <InteraLogo/>
        </a>

      </div>
    </div>
  </nav>


</template>

<style lang="scss" scoped>
.footer-wrapper {
  background: $color-grey;
  width: 100%;
  border-radius: 30px;


  .navigation-item {
    font-size: 14px;
    font-family: $font-bold;
    margin: 15px 10px;
    cursor: pointer;
    color: $color-brown;

    .icon {
      transform: scale(0.5);
    }
  }

  .navigation-item-small {
    font-size: 12px;
    font-family: $font-regular;
    margin: 15px 10px;
    cursor: pointer;
    color: $color-brown;

  }

  .footer-contact-info {
    font-size: 14px;
    text-align: center;
    margin: $spacing-2 0;
  }

  .footer-top, .footer-bottom {
    padding: $spacing-4 40px;
  }

  .footer-middle {
    border-top: 1px solid $color-cta-main;
    border-bottom: 1px solid $color-cta-main;
    padding: $spacing-4 40px;
  }

  .nav-right {
    justify-content: center; /* Align items to the right */
  }

  .nav-left {
    margin-bottom: 30px;
  }

}


.icon {
  cursor: pointer;
}


@media screen and (min-width: 768px) {
  .footer-wrapper {
    .menu-navigation {
      justify-content: center;
    }

    .nav-left, .nav-right {
      display: flex;
      align-items: center;
    }

    .nav-left {
      margin-bottom: 0;
    }

    .nav-right {
      justify-content: flex-end;
    }

    .nav-container {

      grid-template-columns: 1fr auto 1fr; /* Three columns, middle is auto-sized */
      align-items: center; /* Center items vertically */
      width: 100%; /* Full width */
    }

    .navigation-item, .navigation-item-small {
      margin: 0 10px;
    }

    .footer-contact-info {
      text-align: left;
      margin: 0;

    }


  }


}

</style>